import { eligibilityTooltipProps } from '~/pages/ContactsDashboardOld/ContactsDashboardOld.utils';
export function deleteTooltipProps(contact, eligibilityTexts) {
    if (contact.canDelete()) return undefined;
    return eligibilityTooltipProps(contact.deleteEligibility(), 'delete', eligibilityTexts);
}
